define('features/pcu/page',[
  'require',
  'jquery',
  'lib/page-cache',
  'features/recentVehicles',
  'lib/services/batws',
  'lib/transforms/dealer.tmpl.common',
  'lib/util/zip',
  // 'facebook',
  'detectizr',
  'lib/util/tda.config',
  'features/pcu/widgetOrder',
  'cookies',
  'lib/transforms/slp.series',
  'lib/util/langFromUrl',

  // Side Effect Includes
  'jqueryui',
  'lib/loader/series',
  'lib/transforms/series.mapByCode',
], function (
  require,
  $,
  PageCache,
  recentVehicles,
  batws,
  xformDealersCommon,
  zip,
  // facebook,
  detectizr,
  tdaConfig,
  widgetOrder,
  cookies,
  slpSeries,
  langFromUrl
) {
  // Dynamically require BAT Next
  var BATNext;
  var facebook;
  var isListeningToZipChange = false;

  function __parseSeries(seriesArr, seriesMap) {
    var vehSelect = [];
    seriesArr.forEach(function (series) {
      if (BATSiteConfig.disabledVehicles.indexOf(series.series_code) === -1) {
        var seriesObj = series;
        seriesObj.displayName = seriesMap[series.series_code].series_display_name;
        vehSelect.push(seriesObj);
      }
    });
    return vehSelect;
  }

  // BAT-4383
  function __legalCopy(copy) {
    if (tdaConfig.tda.code === 'WWW') {
      return copy.replace('<a href=/%1/legal/>', '<a target="_blank" href="https://www.toyota.com/' + (langFromUrl() === 'es' ? 'espanol/' : '') + 'support/privacy-rights">');
    }
    return copy.replace('%1', tdaConfig.site.context_url);
  }

  var PCUPage = function (el, opts) {
    this.el = el;
    this.opts = opts;
    // Moved out of XSL based depends for webpack purposes
    this.opts.tdaConfig = tdaConfig;
    this.opts.i18n.legalCopy = __legalCopy(this.opts.i18n.legalCopy);
  };

  $.extend(PCUPage.prototype, {
    load: function () {
      var self = this;
      var cacheIds = ['series.raw', 'series.map'];

      PageCache.awaitAll(cacheIds)
        .then(function (res) {
          return res;
        })
        .then(function (res) {
          return new Promise(function (resolve, reject) {
            require(['bat-next'], function (BATNextLib) {
              BATNext = BATNextLib;
              resolve(res);
            }, reject);
          });
        })
        .then(function (res) {
          return new Promise(function (resolve, reject) {
            require(['vendor/facebook/sdk'], function () {
              facebook = window.FB;
              resolve(res);
            }, reject);
          });
        })
        .then(function (res) {
          var series = __parseSeries(res[0].seriesDepthOne.series, res[1]);
          self.drawParent(series);
        })
        .catch(function (err) { console.log('error in PCUPage: ', err); }); // eslint-disable-line no-console
    },

    drawParent: function (series) {
      var self = this;
      var lang = this.opts.i18n.lang;
      var defaultZip = cookies.getItem('isConfirmedZip') === 'true' ? zip.getCookiedDefaultFallback() : '';
      var formLength = this.opts.formLength === 'default' ? 'long' : this.opts.formLength;
      var useFB = this.opts.useFB;

      var dealersStore = new BATNext.Store.DealersStore.createDefaultDealersStore(batws, xformDealersCommon);

      /* setup for each instance of unique pcuFormStore's */
      var pcuFormStoreProvider = {
        submit: function (model) {
          var req = Object.assign({
            successPage: window.location.origin + '/' + tdaConfig.site.context_url + '/request-a-quote/thankyou/',
            errorPage: window.location.origin + '/' + tdaConfig.site.context_url + '/request-a-quote/404/',
          }, model);

          if (req.series && req.series.length) {
            var xformedSeries = slpSeries(req.series);
            if (xformedSeries.moreSeries) {
              req.comments = (req.comments || '') + xformedSeries.moreSeries;
              delete xformedSeries.moreSeries;
            }
            Object.assign(req, xformedSeries);
            delete req.series;
          }
          if (req.offerComment) {
            req.comments = (req.comments || '') + '\n\n:::' + req.offerComment;
          }
          var updatedModel = Object.assign(model, req);

          return batws.slp().getQuote(req)
            .then(function () {
              // Store the full dealer reference to the dealer on the results response
              // This allows the dealer store to be reset and confirmation references to be maintained
              return Object.assign({}, updatedModel, {
                dealer: dealersStore.findDealerByDealerCode(model.dealerCode),
              });
            });
        }
      };

      var pcuFormStoreHidden = Object.assign({}, {
        vehicleMake: 'N/A',
        vehicleModel: 'N/A',
        vehicleYear: 'N/A',
        preferedContact: 'email',
        series: recentVehicles.getMostRecentVehicleId(),
        zip: defaultZip,
        selectedDealer: 'zip',
        deviceType: detectizr.device.type,
        omnitureId: cookies.getItem('xact'),
        mediaTag: cookies.getItem('campaign'),
        tmsSiteAttribute: cookies.getItem('TMSSiteAttr')
      }, this.opts.hiddenFields);


      var pcuStore = new BATNext.PCU.PCUStore({
        widgetStoreFactory: function (widget) {
          var formStore = new BATNext.SLP.FormStore(
            pcuFormStoreProvider,
            pcuFormStoreHidden,
            formLength,
            detectizr.device.type
          );
          formStore.setLang(lang);
          var widgetStore = new BATNext.PCU.WidgetStore({
            reset: function (store) {
              dealersStore.resetAll();
              store.formStore.state = BATNext.SLP.FormStore.FormState.Entry;

              if (store.formStore.formsyRef) {
                store.formStore.formsyRef.reset({ dealerCode: null });
              }
            }
          }, Object.assign({}, {
            seriesByCategory: series,
            defaultZip: defaultZip,
            facebook: facebook,
            tdaConfig: tdaConfig,
            formStore: formStore,
            useFB: useFB,
            kbbProfileId: BATSiteConfig.kbbProfileId[lang]
          }, widget), {});

          return widgetStore;
        },
        userDevice: detectizr.device.type,
        model: this.opts.model,
        widgetOrder: widgetOrder,
      });

      var defaultOpts = {
        stores: {
          pcuStore: pcuStore,
          dealersStore: dealersStore,
        }
      };

      BATNext.PCU.renderPCU(this.el, $.extend({}, defaultOpts, this.opts));
      if (!BATNext.FABController.isMounted()) {
        BATNext.FABController.mountFabContainer(document.getElementById('fab-container'));
      }

      // event listener for when zip code is changed on BAT.
      if (!isListeningToZipChange) {
        isListeningToZipChange = true;

        $(window).on('ZIP_CODE_CHANGED', function () {
          self.drawParent(series); // TODO: Change this to update the stores rather than redraw the parent
        });
      }
    }
  });

  return PCUPage;
});

